import React from 'react';
import styles from './PlaceholderPage.module.css';

const PlaceholderPage = ({ title, features }) => {
  return (
    <div className={styles.placeholder}>
      <h1>{title}</h1>
      
      <div className={styles.card}>
        <p><strong>{title}</strong> - Phase 2+ Implementation</p>
        <p>Features to be implemented:</p>
        <ul>
          {features.map((feature, index) => (
            <li key={index}>✓ {feature}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PlaceholderPage;
